import { useState } from 'react';
import { Input, FormErrorMessage, Box } from '@chakra-ui/react';

const GSTInput = ({ name, value = '', onChange, isEditMode, placeholder }) => {
  const [inputValue, setInputValue] = useState(value);
  const [isValid, setIsValid] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [touched, setTocuched] = useState(false);

  const handleInputChange = (event) => {
    const newValue = event.target.value.toUpperCase(); // Convert input to uppercase
    setInputValue(newValue);

    // GST validation regex
    const regex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}$/;
    const isValidGST = regex.test(newValue);
    setIsValid(isValidGST);

    if(isValidGST){
      setTocuched(false);
    }

    onChange({ target: { name: event.target.name, value: newValue } });
  };

  const handleInputBlur = () => {
    setIsHovered(false);
    if (!isValid) {
      setIsValid(false);
    }
    if(!inputValue){
      setTocuched(false);
      setIsValid(true);
    }
  };

  const handleInputFocus = () => {
    setIsHovered(true);
    setTocuched(true);
  };

  return (
    <>
      <Input
        name={name}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        onFocus={handleInputFocus}
        isInvalid={!isValid && !isHovered}
        disabled={isEditMode}
        placeholder={placeholder}
      />
      {!isValid && touched && !isHovered &&  (
        <Box color={'red'}>
          Please enter a valid GST number
        </Box>
      )}
    </>
  );
};

export default GSTInput;
